"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = () => {
  const event = new CustomEvent('closeAllTooltips');
  window.dispatchEvent(event);
};